import { FULL_FAQS, GLOBAL_CATALOGS } from '../types';

const initialState = {
  isLoading: false,
  menus: [],
  value: '',
  title: '',  // 搜索關鍵詞
  result: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },

  // 
  affairs: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  electrical: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },
  safety: {
    list: [],
    total: 0,
    page: 1,
    rowsPerPage: 10,
    pages: 10,
  },

  // 
  details: {},
};

const faqsReducer = function (state = initialState, action) {
  switch (action.type) {
    case FULL_FAQS.Loading: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case FULL_FAQS.Value: {
      return {
        ...state,
        value: action.payload
      };
    }
    case FULL_FAQS.Title: {
      return {
        ...state,
        title: action.payload
      };
    }
    case FULL_FAQS.List: {
      return {
        ...state,
        result: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Faqs.Root: {
      return {
        ...state,
        menus: action.payload
      };
    }
    case GLOBAL_CATALOGS.Faqs.Affairs.List: {
      return {
        ...state,
        affairs: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Faqs.Electrical.List: {
      return {
        ...state,
        electrical: { ...action.payload }
      };
    }
    case GLOBAL_CATALOGS.Faqs.Safety.List: {
      return {
        ...state,
        safety: { ...action.payload }
      };
    }
    default: {
      return state;
    }
  }
};

export default faqsReducer;
